var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-appointments mt-page"},[_c('h1',[_vm._v(_vm._s(_vm.$i18n.gt('HEADING_APPOINTMENTS')))]),_c('appointment-calendar',{attrs:{"practitioner-view":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }